import { usePostLostCredentialsMutation } from '@/api/api.slice';
import {
  Alert,
  Button,
  getMessageFromError,
  TextField,
  Typography,
} from '@arsnovasystems/ars-front-lib';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import { Link, Stack } from '@mui/material';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * LostCredentials page
 * This is the page when partner have lost password
 *
 * @returns JSX of the component
 */
export const LostCredentials = () => {
  const { t } = useTranslation();
  const [email, setEmail] = React.useState('');
  const [isSuccess, setIsSuccess] = React.useState(false);

  const [postLostCredentials, { isUninitialized, isLoading, error }] =
    usePostLostCredentialsMutation();

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    const res = await postLostCredentials(email);
    if (res.error === undefined) {
      setIsSuccess(true);
    }
  };

  return (
    <Fragment>
      {isUninitialized ?
        <Fragment>
          <Typography>{t('ik.request.to.change.password')}</Typography>
          <TextField
            sx={{ marginTop: 6 }}
            label={t('ik.email')}
            type='email'
            fullWidth
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />

          <Button
            sx={{
              marginTop: 4,
            }}
            loading={isLoading}
            disabled={isSuccess}
            onClick={handleSubmit}
          >
            {t('ik.send')}
          </Button>
        </Fragment>
      : null}
      {error ?
        <Alert>{getMessageFromError(error)}</Alert>
      : null}
      {isSuccess ?
        <>
          <Stack
            direction={'row'}
            sx={{ gap: 2, mt: 2 }}
          >
            <CheckCircleOutlineIcon
              sx={{
                fontSize: '4rem',
              }}
              color={'success'}
            />
            <Typography>{t('ik.lostCredentials.info.emailSent')}</Typography>
          </Stack>
          <Link
            sx={{ mt: 2 }}
            href='/login'
          >
            {t('ik.back.to.login')}
          </Link>
        </>
      : null}
    </Fragment>
  );
};
